import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MyClassSortColumns } from '@app/src/app/modules/tools/teacher-tools/components/tt-my-class/types/tt-my-class.types';

@Component({
  selector: 'mg-sort-arrow',
  templateUrl: './sort-arrow.component.html',
  styleUrls: ['./sort-arrow.component.scss'],
})
export class SortArrowComponent {
  // Inputs

  @Input() activeColumnKey: MyClassSortColumns;
  @Input() columnKey: MyClassSortColumns;
  @Input() sortDirection: 'asc' | 'desc' | null = null;

  // Outputs

  @Output() sortChanged: EventEmitter<MyClassSortColumns> = new EventEmitter();

  // Getters

  get classes() {
    return {
      [this.sortDirection]: true,
    };
  }

  // Constructor

  constructor() {}

  // Public Methods

  toggleSort(): void {
    this.sortChanged.emit(this.columnKey);
  }
}
